<template>
  <div :class="`flight-pad-price-button flight-pad-price-button__${direction}`">
    <div class="flight-pad-price-button__box">
      <div class="flight-pad-price-button__amount">
        <div class="d-flex flex-column">
          <span class="h3 m-0 semibold text-primary">
            <span>{{ currency(flight_offer.price.currency) }}</span>
            {{ number(get_markup(flight_offer).mu_price_medium_per_pax).toFixed(2) }}
          </span>
          <span class="flight-pad-price-button__text text-muted"> per persona </span>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column justify-content-center">
      <p
        :class="`${
          get_availability(get_markup(flight_offer).mu_price).affordable
            ? 'hidden-credit-warning'
            : 'mb-1'
        } credit-warning text-center text-danger`"
        v-b-popover.hover.bottom="
          'Il tuo credito welfare non è sufficiente ad acquistare questa soluzione'
        "
      >
        <span v-html="info" class="text-danger" fill-danger />
        Credito non sufficiente
      </p>
      <b-button variant="cta" @click="select_flight_offer(flight_offer, 'detail')">
        Scegli
      </b-button>
    </div>
  </div>
</template>

<script>
import { get_markup, select_flight_offer } from '@/flight-offer';
import { get_availability, currency } from '@/utilities';
import { info } from '@/components/svg/common';
import { number } from 'mathjs';

export default {
  name: 'flight-pad-price-button',
  props: {
    flight_offer: Object,
    direction: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      info,
    };
  },
  methods: {
    number,
    currency,
    select_flight_offer,
    get_availability,
    get_markup,
  },
};
</script>

<style lang="scss" scoped>
.flight-pad-price-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  justify-items: center;
  height: 100%;

  .hidden-credit-warning {
    max-height: 0px;
    margin: 0;
    padding: 0;
    line-height: 0;
    opacity: 0;
  }
  &__box {
    display: flex;
    font-size: $font-size-lg;
  }
  &__currency {
    margin-right: 6px;
  }
  &__amount {
    width: 100%;
    text-align: center;
    margin-bottom: 5px;
  }
  &__text {
    font-size: $font-size-sm;
    text-align: center;
  }

  &__horizontal {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 30px;

    &__text {
      text-align: start;
    }
  }

  @include media-breakpoint-down(md) {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-top: $grid-gutter-width / 3;

    &__text {
      text-align: start;
    }
  }

  button {
    padding: 10px;
  }
}
</style>
